module.exports = __webpack_public_path__ + "img/1568857582.89cdc88d.jpg";